// Google Analytics 4 (gtag.js) — loaded only when a Measurement ID is configured.
const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const analyticsEnabled = Boolean(measurementId);

let initialized = false;

export function initAnalytics() {
  if (!analyticsEnabled || initialized || typeof window === "undefined") return;
  initialized = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  // Manual page_view control for this single-page app.
  gtag("config", measurementId, { send_page_view: false });
}

export function trackPageView({ title, path } = {}) {
  if (!analyticsEnabled || typeof window.gtag !== "function") return;
  const p = path || window.location.pathname + window.location.search;
  window.gtag("event", "page_view", {
    page_title: title || document.title,
    page_location: new URL(p, window.location.origin).href,
    page_path: p,
  });
}

export function trackEvent(name, params = {}) {
  if (!analyticsEnabled || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
